import { PaginationSchema } from "@/components/paginate/types";
import { z } from "zod";

export const TagTypeSchema = z.enum(["custom", "system"]);

export const BaseTagSchema = z.object({
  name: z.string(),
  rk: z.string().optional(),
  display_name: z.string().optional(),
  description: z.string().nullable(),
});

export type BaseTag = z.infer<typeof BaseTagSchema>;

export const TagSchema = BaseTagSchema.extend({
  name: z.string().optional(),
  rk: z.string(),
  display_name: z.string(),
  tag_type: TagTypeSchema,
  usage: z.number(),
  created_by: z.number(),
});

export type Tag = z.infer<typeof TagSchema>;

export const TagsResponseSchema = z.object({
  ...PaginationSchema.shape,
  items: z.array(TagSchema),
});

export type TagsResponse = z.infer<typeof TagsResponseSchema>;

export interface GetTagsParams {
  search?: string;
  page?: number;
  size?: number;
  owners?: string[];
}

export interface AddTagToNodeRequest {
  tag_rk: string;
  entity: {
    datastore_rk: string;
    datastore_type: string;
    cluster_rk: string;
    schema_rk: string;
    table_rk: string;
    column_rk?: string;
  };
  tag?: Tag;
}

export const AssociateTagResponseSchema = z.object({ message: z.string(), id: z.string() });
